/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransferredToken } from './TransferredToken';
import {
    TransferredTokenFromJSON,
    TransferredTokenFromJSONTyped,
    TransferredTokenToJSON,
} from './TransferredToken';

/**
 * 
 * @export
 * @interface TransferredTokenResponse
 */
export interface TransferredTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TransferredTokenResponse
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferredTokenResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof TransferredTokenResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {TransferredToken}
     * @memberof TransferredTokenResponse
     */
    data?: TransferredToken;
}

/**
 * Check if a given object implements the TransferredTokenResponse interface.
 */
export function instanceOfTransferredTokenResponse(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function TransferredTokenResponseFromJSON(json: any): TransferredTokenResponse {
    return TransferredTokenResponseFromJSONTyped(json, false);
}

export function TransferredTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferredTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : TransferredTokenFromJSON(json['data']),
    };
}

export function TransferredTokenResponseToJSON(value?: TransferredTokenResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': TransferredTokenToJSON(value['data']),
    };
}

